import React from "react";
import T from "prop-types";
import { Modal, Close, Header } from "MODULES/shared/components/Modal";
import Form from "./Form";

function CreateSecondExchangeModal({ lineItem, open, close, currentUser }) {
  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Please Confirm Seller Credit</h4>
      </Header>
      <Form
        close={close}
        selectedSeller={lineItem.seller}
        lineItem={lineItem}
        currentUser={currentUser}
        initialValues={{
          seller_id: lineItem.seller_id,
          second_seller_id: lineItem.second_seller_id
        }}
      />
    </Modal>
  );
}

export default CreateSecondExchangeModal;

CreateSecondExchangeModal.propTypes = {
  open: T.bool.isRequired,
  close: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/CreateSecondExchange/CreateSecondExchangeModal.jsx